"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const portal_vue_1 = __importDefault(require("portal-vue"));
const vue_1 = __importDefault(require("vue"));
const Modal = vue_1.default.extend({
    data() {
        return {
            currentModal: null,
        };
    },
    methods: {
        show(name) {
            this.currentModal = name;
        },
        hide() {
            this.currentModal = null;
        },
    },
});
exports.default = {
    install: (Vue) => {
        Vue.use(portal_vue_1.default);
        const modalInstance = new Modal();
        Vue.$modal = modalInstance;
        Vue.prototype.$modal = modalInstance;
    },
};
